<template>
    <div
        v-if="isOpen"
        class="fixed inset-0 z-30"
    >
        <div
            class="absolute bg-slate-400 inset-0 opacity-15"
            @click="closeModal"
        ></div>

        <div class="absolute bg-white bottom-0 inset-x-0 modal-sheet overflow-y-scroll p-7 shadow-md top-10">
            <div class="flex mb-7">
                <span
                    class="icon icon-close"
                    @click="closeModal"
                ></span>
            </div>

            <slot></slot>
        </div>
    </div>
</template>

<script>
/**
 * @deprecated
 */
export default {
    name: 'ModalSheet',
    props: {
        open: {
            default: false,
            type: Boolean,
        },
    },
    emits: ['closed'],

    data() {
        return {
            isOpen: false,
            previousBodyOverflow: '',
        };
    },

    watch: {
        open(isOpen) {
            this.isOpen = isOpen;

            if (isOpen) {
                this.previousBodyOverflow = document.body.style.overflow;
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = this.previousBodyOverflow;
            }
        },
    },

    methods: {
        closeModal() {
            this.$emit('closed');
            this.isOpen = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.modal-sheet {
    animation: slide-in-bottom 250ms ease-in-out forwards;
}
</style>
